// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root___2_PF","container":"style_container__f7EiW g-grid-container","link":"style_link__Xg1jq mds-typography-body-200"};